import { FC, useEffect } from "react";
import { useId, Input, Label, Button, Select, Checkbox, Text, RadioGroup, Radio, Field, List, ListItem, makeStyles, tokens, mergeClasses, Card } from "@fluentui/react-components";

// import { motionTokens, createPresenceComponent, PresenceGroup } from '@fluentui/react-motions-preview';
import { accessTokenInfo$ } from "../oauth/oauth";
import { nodeServer } from "../constants";

import { Controller, useFieldArray, useForm } from "react-hook-form";
//import { IMemberInfo } from "../store/member";
// import { statesArray } from "../states";
import { IConference, IConferenceAttendee, IRegistrationOption, RegistrationOptionType } from "./conferenceTypes";
import { QueryObserverResult, RefetchOptions } from "@tanstack/react-query";
import { createSearchParams, URLSearchParamsInit, useNavigate } from "react-router-dom";
import FormInput from "../utility/FormInput";
// import { FontSize } from "ckeditor5";

interface IRegistrationFormProps {
    attendee: IConferenceAttendee;
    conference: IConference;
    readonly?: boolean;
    refetch?: (
        options?: RefetchOptions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) => Promise<QueryObserverResult<any, Error>>;
}

const useStyles = makeStyles({
    selectedInfo: {
        marginTop: "16px",
    },
    buttonWrapper: {
        alignSelf: "center",
    },
    item: {
        cursor: "pointer",
        padding: "5px",
        //padding: "2px 6px",
        // justifyContent: "margi",
    },
    itemSelected: {
        backgroundColor: tokens.colorSubtleBackgroundSelected,
        "@media (forced-colors:active)": {
            background: "Highlight",
        },
    },
    personaSelected: {
        "@media (forced-colors:active)": {
            forcedColorAdjust: "none",
            color: "HighlightText",
        },
    },
});

const RegistrationForm: FC<IRegistrationFormProps> = (props: IRegistrationFormProps) => {
    const navigate = useNavigate();

    const {
        control,
        handleSubmit,
        register,
        setValue,
        watch,
        formState: { errors },
    } = useForm<IConferenceAttendee>({
        defaultValues: props.attendee,
    });

    const { fields } = useFieldArray({
        control,
        name: "details",
    });

    const valueWatchers = fields.map((v: IRegistrationOption, i: number) => {
        if (v.optionType === RegistrationOptionType.choiceDetails) {
            return watch(`details.${i}.value`);
        } else if ((v.options as string[])?.includes("Other")) {
            return watch(`details.${i}.value`);
        } else {
            return null;
        }
    });

    useEffect(() => {
        Object.keys(props.attendee).forEach((key: any) => {
            setValue(key, props.attendee[key]);
        });
        if (props.attendee.details) {
            (props.attendee.details as IRegistrationOption[]).forEach((val: IRegistrationOption, i: number) => {
                setValue(`details.${i}.value`, val.value);
            });
        }
    }, [props.attendee, setValue]);

    const onSubmit = async (data: IConferenceAttendee) => {
        console.log(data);
        data.details = JSON.stringify(data.details);
        const headers = new Headers();
        headers.append("Content-Type", "application/json");

        if (data.id) {
            if (accessTokenInfo$.value != null && accessTokenInfo$.value.accessToken != null) {
                headers.append("Authorization", "Bearer " + accessTokenInfo$.value.accessToken);
                // registration already exists, just update it
                const response = await fetch(nodeServer + `conference/register/${data.id}`, {
                    method: "put",
                    headers: headers,
                    body: JSON.stringify(data),
                });
                if (response.ok) {
                    const responseJson: { user: IConferenceAttendee; error?: string } = await response.json();
                    console.log(responseJson);

                    navigate({
                        pathname: "/conference/confirmation",
                        search: createSearchParams({
                            registration: "updated",
                            ...responseJson.user,
                        } as unknown as URLSearchParamsInit).toString(),
                    });
                    // if (data.payby === "paypal") {
                    //     window.open(`https://www.paypal.com/cgi-bin/webscr?cmd=_xclick&amp;business=memberfee@2yc3.org&amp;item_name=${data.institution}_${data.first}_${data.last}&amp;amount={$due}`, "_blank", "rel=noopener noreferrer");
                    // }
                } else {
                    console.log("IT BROKE");
                    if (props.refetch) props.refetch();
                }
            }
        } else {
            // new registration

            const response = await fetch(nodeServer + "conference/register", {
                method: "post",
                headers: headers,
                body: JSON.stringify(data),
            });
            if (response.ok) {
                const responseJson: { user?: IConferenceAttendee; error?: string } = await response.json();
                console.log(responseJson);
                navigate({
                    pathname: "/conference/confirmation",
                    search: createSearchParams({
                        registration: "updated",
                        ...responseJson.user,
                    } as unknown as URLSearchParamsInit).toString(),
                });
                // if (data.payby === "paypal") {
                //     window.open(`https://www.paypal.com/cgi-bin/webscr?cmd=_xclick&amp;business=memberfee@2yc3.org&amp;item_name=${data.institution}_${data.first}_${data.last}&amp;amount={$due}`, "_blank", "rel=noopener noreferrer");
                // }
            } else {
                console.log("IT BROKE");
                if (props.refetch) props.refetch();
            }
        }
    };

    const classes = useStyles();

    const registrationOptionId = useId("registrationOption");
    return (
        <>
            <form method="POST" onSubmit={handleSubmit(onSubmit)} style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                <Controller
                    name="payby"
                    control={control}
                    render={({ field }) => (
                        <>
                            <Field label={"Payment Method"} required>
                                {props.readonly ? (
                                    <Input {...field} type="text" readOnly={props.readonly} appearance={props.readonly ? "underline" : "outline"} />
                                ) : (
                                    <RadioGroup layout="horizontal" {...field} required>
                                        <Radio value="check" label="Check" />
                                        <Radio value="paypal" label="Paypal" />
                                    </RadioGroup>
                                )}
                            </Field>
                        </>
                    )}
                />


                <FormInput name="due" control={control} label="Cost" readonly={true} contentBefore={<Text size={300}>$</Text>}/>

                <FormInput name="first" control={control} label="First Name" required={true} readonly={props.readonly} />
                <FormInput name="last" control={control} label="Last Name" required={true} readonly={props.readonly} />
                <FormInput name="institution" control={control} label="Institution" required={true} readonly={props.readonly} />

                <FormInput
                    name="email"
                    type="email"
                    control={control}
                    label="Email"
                    required={true}
                    readonly={props.readonly}
                    rules={{
                        pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "Invalid email address",
                        },
                    }}
                    error={errors.email}
                    autoComplete={"email"}
                />

                {fields.map((v: IRegistrationOption, i: number) => {
                    if (v.public) {
                        switch (v.optionType) {
                            case RegistrationOptionType.text:
                                return (
                                    <FormInput key={v.name} 
                                        name={`details.${i}.value`} 
                                        control={control} 
                                        label={v.name} 
                                        required={true} 
                                        readonly={props.readonly} />
                
                                );
                            case RegistrationOptionType.boolean:
                                return (
                                    <div key={v.name}>
                                        <Controller
                                            name={`details.${i}.value`}
                                            control={control}
                                            render={({ field }) => (
                                                <Checkbox
                                                    onClick={(e) => {
                                                        if (props.readonly) e.currentTarget.checked = field.value as boolean;
                                                    }}
                                                    readOnly={props.readonly}
                                                    checked={field.value as boolean}
                                                    onChange={field.onChange}
                                                    onBlur={field.onBlur}
                                                    label={v.name}
                                                />
                                            )}
                                        />
                                    </div>
                                );
                            case RegistrationOptionType.choiceDetails:
                                return (
                                    <div key={v.name}>
                                        <Label required>{v.name}</Label>
                                            {props.readonly ? (
                                                <Controller
                                                name={`details.${i}.value`}
                                                control={control}
                                                render={({ field }) => {
                                                    return (
                                                        <>
                                                        <br/>
                                                            <Input
                                                                 style={{width: "100%"}}
                                                                 value={(field.value as string)}
                                                                type={"text"}
                                                                readOnly={true}
                                                                appearance={"underline"}
                                                                size={ "medium"}
                                                            />
                                                            </>
                                                        
                                                    );
                                                }}
                                            ></Controller>
                                            ) : (
                                                <>
                                                    <br/>
                                                    <Text italic>Choose One...</Text>
                                                    <Controller
                                                        name={`details.${i}.value`}
                                                        control={control}
                                                        rules={{
                                                            required: true,
                                                        }}
                                                        render={({ field }) => (
                                                            <Card appearance="filled-alternative">
                                                                <List
                                                                    selectedItems={[field.value as string]}
                                                                    selectionMode="single"
                                                                    ref={field.ref}
                                                                    onBlur={field.onBlur}
                                                                    onSelectionChange={(e, data) => {
                                                                        field.onChange(e);
                                                                        setValue(`details.${i}.value`, data.selectedItems[0] as string);
                                                                    }}
                                                                >
                                                                    {v.options!.map((v) => {
                                                                        return (
                                                                            <ListItem key={v.main} value={v.main} data-value={v.main} className={mergeClasses(classes.item, valueWatchers[i] === v.main && classes.itemSelected)}>
                                                                                <div style={{ display: "flex", flexDirection: "column", marginLeft: 5 }}>
                                                                                    <Text size={400}>{v.main}</Text>
                                                                                    <Text size={200}>&nbsp; {v.details}</Text>
                                                                                </div>
                                                                            </ListItem>
                                                                        );
                                                                    })}
                                                                </List>
                                                            </Card>
                                                        )}
                                                    />
                                                    {valueWatchers[i] === "Other" && <FormInput name={`details.${i}.value2`} type="text" control={control} label="Other" required={true} readonly={props.readonly} />}
                                                </>
                                            )}
                                        
                                    </div>
                                );
                            case RegistrationOptionType.choiceMultiselect:
                                return (
                                    <div key={v.name}>
                                        <Label required>{v.name}</Label>
                                            {props.readonly ? (
                                               <Controller
                                               name={`details.${i}.value`}
                                               control={control}
                                               render={({ field }) => {
                                                   return (
                                                       <>
                                                       <br/>
                                                           <Input
                                                                style={{width: "100%"}}
                                                                value={(field.value as string[]).join(", ")}
                                                               type={"text"}
                                                               readOnly={true}
                                                               appearance={"underline"}
                                                               size={ "medium"}
                                                           />
                                                           </>
                                                       
                                                   );
                                               }}
                                           ></Controller>
                                            ) : (
                                                <>
                                                    <Text italic>Choose One...</Text>
                                                    <Controller
                                                        name={`details.${i}.value`}
                                                        control={control}
                                                        rules={{
                                                            required: true,
                                                        }}
                                                        render={({ field }) => (
                                                            <Card appearance="filled-alternative">
                                                                <List
                                                                    selectedItems={field.value as string[]}
                                                                    selectionMode="multiselect"
                                                                    ref={field.ref}
                                                                    onBlur={field.onBlur}
                                                                    onSelectionChange={(e, data) => {
                                                                        field.onChange(e);
                                                                        setValue(`details.${i}.value`, data.selectedItems as string[]);
                                                                    }}
                                                                >
                                                                    {v.options!.map((v) => {
                                                                        return (
                                                                            <ListItem key={v} value={v} data-value={v} className={mergeClasses(classes.item, valueWatchers[i] === v.main && classes.itemSelected)}>
                                                                                <div style={{ display: "flex", flexDirection: "column", marginLeft: 5 }}>
                                                                                    <Text size={400}>{v}</Text>
                                                                                  
                                                                                </div>
                                                                            </ListItem>
                                                                        );
                                                                    })}
                                                                </List>
                                                            </Card>
                                                        )}
                                                    />
                                                    {valueWatchers[i] === "Other" && <FormInput name={`details.${i}.value2`} type="text" control={control} label="Other" required={true} readonly={props.readonly} />}
                                                </>
                                            )}
                                        
                                    </div>
                                );
                            case RegistrationOptionType.choice:
                                return (
                                    <div key={v.name}>
                                        <Field label={v.name} required={true}>
                                            {props.readonly ? (
                                                <>
                                                <Controller
                                                name={`details.${i}.value`}
                                                control={control}
                                                render={({ field }) => {
                                                    return (
                                                        <>
                                             
                                                            <Input
                                                                 style={{width: "100%"}}
                                                                 value={(field.value as string)}
                                                                type={"text"}
                                                                readOnly={true}
                                                                appearance={"underline"}
                                                                size={ "medium"}
                                                            />
                                                            </>
                                                        
                                                    );
                                                }}
                                            ></Controller>
                                                {valueWatchers[i] === "Other" && (<><Controller
                                                name={`details.${i}.value2`}
                                                control={control}
                                                render={({ field }) => {
                                                    return (
                                                        <>
                                                            <Input
                                                                 style={{width: "100%"}}
                                                                 value={(field.value as string)}
                                                                type={"text"}
                                                                readOnly={true}
                                                                appearance={"underline"}
                                                                size={ "medium"}
                                                            />
                                                            </>
                                                        
                                                    );
                                                }}
                                            ></Controller></>)}
                                                </>
                                            ) : (
                                                <>
                                                    <Select id={registrationOptionId + v.name} required {...register(`details.${i}.value`)}>
                                                        {v.options!.map((v) => {
                                                            return (
                                                                <option key={v} value={v}>
                                                                    {v}
                                                                </option>
                                                            );
                                                        })}
                                                    </Select>
                                                    {valueWatchers[i] === "Other" && <FormInput name={`details.${i}.value2`} type="text" control={control} label="Other" required={true} readonly={props.readonly} />}
                                                </>
                                            )}
                                        </Field>
                                    </div>
                                );
                        }
                    }
                })}
                {errors.root?.message}

                {props.readonly || (
                    <Button type="submit" appearance="primary">
                        {props.attendee && props.attendee.id ? "Update Registration" : "Submit Registration"}
                    </Button>
                )}
            </form>
        </>
    );
};

export default RegistrationForm;
